import { Mail, MapPin, Phone, Instagram, Linkedin, Globe } from "lucide-react";
import { Logo } from "./Logo";
import { BRAND, WHATSAPP_URL } from "@/lib/constants";
import { serviceList } from "@/lib/servicesData";

const NAV_LINKS = [
  { id: "inicio", label: "Início" },
  { id: "solucoes", label: "Soluções" },
  { id: "diferenciais", label: "Diferenciais" },
  { id: "operacao", label: "Operação" },
  { id: "contato", label: "Contato" },
];

const FooterNav = () => (
  <div className="lg:col-span-3">
    <h4 className="text-sm font-bold uppercase tracking-[0.16em] text-[#1F2937]">
      Navegação
    </h4>
    <ul className="mt-5 space-y-3">
      {NAV_LINKS.map((l) => (
        <li key={l.id}>
          <a
            href={`/#${l.id}`}
            data-testid={`footer-link-${l.id}`}
            className="text-[#64748B] hover:text-[#3532B3] transition-colors"
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>

    <h4 className="mt-8 text-sm font-bold uppercase tracking-[0.16em] text-[#1F2937]">
      Soluções
    </h4>
    <ul className="mt-3 space-y-2">
      {serviceList.map((s) => (
        <li key={s.slug}>
          <a
            href={`/solucoes/${s.slug}`}
            data-testid={`footer-service-${s.slug}`}
            className="text-[#64748B] hover:text-[#3532B3] transition-colors"
          >
            {s.name}
          </a>
        </li>
      ))}
    </ul>

    <h4 className="mt-8 text-sm font-bold uppercase tracking-[0.16em] text-[#1F2937]">
      Trabalhe conosco
    </h4>
    <a
      href="/vagas/enfermeiro-adm-emq"
      data-testid="footer-job-link"
      className="mt-3 inline-block text-[#64748B] hover:text-[#3532B3] transition-colors"
    >
      Vaga: Enfermeiro(a) Administrativo
    </a>
  </div>
);

const FooterContact = () => (
  <div className="lg:col-span-5">
    <h4 className="text-sm font-bold uppercase tracking-[0.16em] text-[#1F2937]">
      Contato
    </h4>
    <ul className="mt-5 space-y-4 text-[#64748B]">
      <li className="flex items-start gap-3">
        <Mail size={18} className="text-[#3787F5] mt-0.5" />
        <a
          href={`mailto:${BRAND.email}`}
          data-testid="footer-email"
          className="hover:text-[#3532B3] transition-colors"
        >
          {BRAND.email}
        </a>
      </li>
      <li className="flex items-start gap-3">
        <Phone size={18} className="text-[#3787F5] mt-0.5" />
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-phone"
          className="hover:text-[#3532B3] transition-colors"
        >
          {BRAND.phone}
        </a>
      </li>
      <li className="flex items-start gap-3">
        <Globe size={18} className="text-[#3787F5] mt-0.5" />
        <a
          href={`https://${BRAND.website}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-website"
          className="hover:text-[#3532B3] transition-colors"
        >
          {BRAND.website}
        </a>
      </li>
      <li className="flex items-start gap-3">
        <Instagram size={18} className="text-[#3787F5] mt-0.5" />
        <a
          href={BRAND.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="hover:text-[#3532B3] transition-colors"
        >
          {BRAND.instagram}
        </a>
      </li>
      <li className="flex items-start gap-3">
        <Linkedin size={18} className="text-[#3787F5] mt-0.5" />
        <a
          href={BRAND.linkedinUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-linkedin"
          className="hover:text-[#3532B3] transition-colors"
        >
          /{BRAND.linkedin}
        </a>
      </li>
      <li className="flex items-start gap-3">
        <MapPin size={18} className="text-[#3787F5] mt-0.5" />
        <address
          data-testid="footer-address"
          className="leading-relaxed not-italic"
        >
          {BRAND.address}
        </address>
      </li>
    </ul>
  </div>
);

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F6F8FB] border-t border-[#E5EAF2] pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Logo testid="footer-logo" />
            <p className="mt-5 text-[#64748B] leading-relaxed max-w-sm">
              Entrevista qualificada, segurança técnica e inteligência de
              carteira para a saúde suplementar.
            </p>
          </div>

          <FooterNav />
          <FooterContact />
        </div>

        <div className="mt-14 pt-8 border-t border-[#E5EAF2] flex flex-col sm:flex-row gap-3 items-center justify-between text-sm text-[#64748B]">
          <p data-testid="footer-copyright">
            © {year} {BRAND.name}. Todos os direitos reservados.
          </p>
          <p>Healthtech para saúde suplementar · Vila Velha · ES</p>
        </div>
      </div>
    </footer>
  );
};
